import React, { useEffect } from 'react';
import '../styles/App.css';
import AOS from 'aos';
import 'aos/dist/aos.css';

import Topbar from '../components/Topbar';
import Home from './Home.js';
import About from './About.js';
import Education from './Education.js';
import Projects from './Projects.js';
import Footer from '../components/Footer.js';
import Contacts from './Contacts.js';
import Experience from './Experience.js';
import MarqueeStrip from '../components/MarqueeStrip.js';
import NameSeparator from '../components/NameSeparator.js';

function App() {
  useEffect(() => {
    AOS.init({ duration: 1000, offset: 50, once: true, easing: 'ease-out-cubic' });
  }, []);

  return (
    <div className="app-container">
      <Topbar />
      <div className="main-scroll-container">
        <section id="home">
          <Home />
        </section>
        <section id="about">
          <About />
        </section>        
        <MarqueeStrip />
        <section id="experience">
          <Experience />
        </section>
        <section id="projects">
          <Projects />
        </section>
        <section id="Education">
          <Education />
        </section>
        <div className="name-contacts-zone">
          {/* Wavy gradient background — SVG turbulence displaces the color boundary */}
          <svg className="ncz-bg-svg" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
            <defs>
              <linearGradient id="ncz-grad" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%"   stopColor="#FFFCF5" />
                <stop offset="24%"  stopColor="#FFFCF5" />
                <stop offset="42%"  stopColor="#dbd7cf" />
                <stop offset="60%"  stopColor="#7a8a90" />
                <stop offset="78%"  stopColor="#2e3a42" />
                <stop offset="100%" stopColor="#141c22" />
              </linearGradient>
              {/* Big soft cream circle blob in upper-left */}
              <radialGradient id="ncz-blob" cx="30%" cy="28%" r="38%" fx="30%" fy="28%">
                <stop offset="0%"   stopColor="#FFFCF5" stopOpacity="0.55" />
                <stop offset="100%" stopColor="#FFFCF5" stopOpacity="0" />
              </radialGradient>
              {/* Desaturated dark blob lower-right */}
              <radialGradient id="ncz-blob2" cx="72%" cy="75%" r="32%" fx="72%" fy="75%">
                <stop offset="0%"   stopColor="#253038" stopOpacity="0.5" />
                <stop offset="100%" stopColor="#253038" stopOpacity="0" />
              </radialGradient>
              <filter id="ncz-warp" x="-15%" y="-15%" width="130%" height="130%" colorInterpolationFilters="sRGB">
                <feTurbulence type="turbulence" baseFrequency="0.013 0.035" numOctaves="3" seed="17" result="noise" />
                <feDisplacementMap in="SourceGraphic" in2="noise" scale="110" xChannelSelector="R" yChannelSelector="G" />
              </filter>
            </defs>
            {/* Base wavy gradient */}
            <rect x="-15%" y="-15%" width="130%" height="130%" fill="url(#ncz-grad)" filter="url(#ncz-warp)" />
            {/* Circle blob overlays (no warp so they stay soft/round) */}
            <rect x="0" y="0" width="100%" height="100%" fill="url(#ncz-blob)" />
            <rect x="0" y="0" width="100%" height="100%" fill="url(#ncz-blob2)" />
          </svg>
          <NameSeparator />
          <section id="contacts">
            <Contacts />
          </section>
        </div>
        <Footer />
      </div>
    </div>
  );
}

export default App;